<template>
  <modal 
    name="add-employment-modal" 
    :pivotY="0.2"
    height="auto"
    :width="'680px'"
    @before-open="beforeOpen">
    
    <div class="modal-header">
      <div class="modal-title">
        What type of employment would you like to add?
      </div>

      <a href="#"
        @click.prevent="$modal.hide('add-employment-modal')"
        class="text-gray-500 hover:text-gray-700">
        <svg width="20" height="20" stroke-width="2" class="align-middle" stroke="currentColor" fill="none">
          <use xlink:href="/static/img/feather-sprite.svg#x-circle"/>
        </svg>
      </a>
    </div>

    <div class="modal-body">

      <!-- <div class="flex items-center mb-4" v-if="showCurrentOrPrevious">
        <div class="text-sm">
          <input type="radio" v-model="currentOrPrevious" value="current" id="input-type-current" />
          <label for="input-type-current" class="ml-2 mr-8">Current employment</label>

          <input type="radio" v-model="currentOrPrevious" value="previous" id="input-type-previous" />
          <label for="input-type-previous" class="ml-2">Previous employment</label>
        </div>
      </div> -->

      <div class="flex flex-wrap -mx-2">
				<div class="w-1/4 px-2">
          <button class="item-button" v-on:click="addEmploymentLocal(0)">
            <img src="https://img.icons8.com/plasticine/100/000000/work.png" class="inline w-12" />
            <div class="mt-2">Full Time</div>
          </button>
        </div>

        <div class="w-1/4 px-2">
          <button class="item-button" v-on:click="addEmploymentLocal(1)">
            <img src="https://img.icons8.com/plasticine/100/000000/overtime.png" class="inline w-12" />
            <div class="mt-2">Part Time</div>
          </button>
        </div>

        <div class="w-1/4 px-2">
          <button class="item-button" v-on:click="addEmploymentLocal(11)">
            <img src="https://img.icons8.com/plasticine/100/000000/bookmark--v1.png" class="inline w-12" />
            <div class="mt-2">Casual</div>
          </button>
        </div>

        <div class="w-1/4 px-2">
          <button class="item-button" v-on:click="addEmploymentLocal(2)">
            <img src="https://img.icons8.com/plasticine/100/000000/clock.png" class="inline w-12" />
            <div class="mt-2">Contractor</div>
          </button>
        </div>
      </div>


      <div class="flex flex-wrap -mx-2 mt-4">
         <div class="w-1/4 px-2">
          <button class="item-button" v-on:click="addEmploymentLocal(12)">
            <img src="https://img.icons8.com/plasticine/100/000000/share-2.png" class="inline w-12" />
            <div class="mt-2">Commission</div>
          </button>
        </div>

        <div class="w-1/4 px-2">
          <button class="item-button" v-on:click="addEmploymentLocal(13)">
            <img src="https://img.icons8.com/plasticine/100/000000/partly-cloudy-day--v1.png" class="inline w-12" />
            <div class="mt-2">Seasonal</div>
          </button>
        </div>

        <div class="w-1/4 px-2">
          <button class="item-button" v-on:click="addEmploymentLocal(4)">
            <img src="https://img.icons8.com/plasticine/100/000000/small-business.png" class="inline w-12" />
            <div class="mt-2">Self Employed</div>
          </button>
        </div>

          <div class="w-1/4 px-2">
          <button class="item-button" v-on:click="addEmploymentLocal(3)">
            <img src="https://img.icons8.com/plasticine/100/000000/org-unit.png" class="inline w-12" />
            <div class="mt-2">Temporary</div>
          </button>
        </div>

      </div>

      <div class="flex flex-wrap -mx-2 mt-4">
        <div class="w-1/4 px-2">
          <button class="item-button" v-on:click="addEmploymentLocal(5)">
            <img src="https://img.icons8.com/plasticine/100/000000/home.png" class="inline w-12" />
            <div class="mt-2">Home Duties</div>
          </button>
        </div>

        <div class="w-1/4 px-2">
          <button class="item-button" v-on:click="addEmploymentLocal(6)">
            <img src="https://img.icons8.com/plasticine/100/000000/beach-umbrella.png" class="inline w-12" />
            <div class="mt-2">Retired</div>
          </button>
        </div>
        <div class="w-1/4 px-2">
          <button class="item-button" v-on:click="addEmploymentLocal(7)">
            <img src="https://img.icons8.com/plasticine/100/000000/student-male.png" class="inline w-12" />
            <div class="mt-2">Student</div>
          </button>
        </div>

        <div class="w-1/4 px-2">
          <button class="item-button" v-on:click="addEmploymentLocal(8)">
            <img src="https://img.icons8.com/plasticine/100/000000/road-closure.png" class="inline w-12" />
            <div class="mt-2">Not Employed</div>
          </button>
        </div>
      </div>

      <div class="flex flex-wrap -mx-2 mt-4">

        <div class="w-1/4 px-2">
          <button class="item-button" v-on:click="addEmploymentLocal(9)">
            <img src="https://img.icons8.com/plasticine/100/000000/museum.png" class="inline w-12" />
            <div class="mt-2">Government Benefits</div>
          </button>
        </div>

        <div class="w-1/4 px-2">
          <button class="item-button" v-on:click="addEmploymentLocal(10)">
            <img src="https://img.icons8.com/plasticine/100/000000/star--v1.png" class="inline w-12" />
            <div class="mt-2">Other</div>
          </button>
        </div>
      </div>
    </div>
  </modal>
</template>

<script>
  export default {

    props : {
      addEmployment : {
        type    : Function,
        required: true
      } 
    },

    data() {
      return {
        currentOrPrevious    : 'current',
        showCurrentOrPrevious: false
      }
    },

    methods : {
      beforeOpen(event) {
        if(event.params != null && event.params.currentOrPrevious != null) {
          this.currentOrPrevious     = event.params.currentOrPrevious
          this.showCurrentOrPrevious = false
        }

        else {
          this.currentOrPrevious     = 'current'
          this.showCurrentOrPrevious = false
        }
      },

      addEmploymentLocal(status) {
        this.addEmployment(this.currentOrPrevious, status)
        this.$modal.hide('add-employment-modal')
      },
    }
  }
</script>